import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RocketIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RocketIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RocketIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RocketIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RocketIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M15.2 17.8H4v-4l2.437-3.046A17.833 17.833 0 016.4 9.637C6.4 6.772 8.8 3.36 12 1c3.2 2.36 5.6 5.772 5.6 8.637 0 .354-.012.73-.037 1.117L20 13.8v4h-4.8zm1.186-1.6H18.4v-1.839l-1.1-1.374c-.202 1.171-.507 2.312-.915 3.213zm-8.771 0c-.408-.901-.713-2.042-.916-3.213L5.6 14.361V16.2h2.015zm7.97 3.2L12 23.4l-3.585-4h7.17zM12 21l1.536-1.6h-3.072L12 21zM8 9.637c0 2.61.694 5.579 1.42 6.563h5.16c.726-.984 1.42-3.952 1.42-6.563 0-1.93-1.57-4.51-4-6.594-2.43 2.084-4 4.664-4 6.594zm4 .963a1.6 1.6 0 110-3.2 1.6 1.6 0 010 3.2z" />
    </svg>
  )
);
RocketIcon.displayName = "RocketIcon";
export default RocketIcon;
